import { Route, Routes, Navigate } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import AppLayout from "@/app/layout/AppLayout";
import SignIn from "@/pages/auth/SignIn";
import SignUp from "@/pages/auth/SignUp";
import Blank from "@/pages/Blank";
import NotFound from "@/pages/OtherPage/NotFound";
import RentingsPage from "@/pages/rentings/RentingsPage";
import ClientsPage from "@/pages/clients/ClientsPage";
import CarsPage from "@/pages/cars/CarsPage";
import CarModelsPage from "@/pages/car-models/CarModelsPage";
import RentingDetailsPage from "@/pages/rentings/RentingDetailsPage";
import CarDetailsPage from "@/pages/cars/CarDetailsPage";
import ClientDetailsPage from "@/pages/clients/ClientDetailsPage";
import CarModelDetailsPage from "@/pages/car-models/CarModelDetailsPage";
import RentingsCalendarPage from "@/pages/rentings/RentingsCalendarPage";
import ProfilePage from "@/pages/profile/ProfilePage";
import SettingsPage from "@/pages/profile/SettingsPage";
import ReportDetailsPage from "@/pages/cars/ReportDetailsPage";
import ActivitiesPage from "@/pages/activities/ActivitiesPage";
import TeamPage from "@/pages/team/TeamPage";
import CreateReportPage from "@/pages/rentings/reports/CreateReportPage";
import EditReportPage from "@/pages/rentings/reports/EditReportPage";

export default function App() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/rentings" replace />} />
        <Route path="/rentings" element={<RentingsPage />} />
        <Route path="/activities" element={<ActivitiesPage />} />
        <Route path="/blank" element={<Blank />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/blank" element={<Blank />} />
        <Route path="/rent-calendar" element={<RentingsCalendarPage />} />
        <Route path="/rentings/:id" element={<RentingDetailsPage />} />
        <Route path="/rentings/:id/reports/new" element={<CreateReportPage />} />
        <Route path="/rentings/:id/reports/:reportId/edit" element={<EditReportPage />} />
        <Route path="/reports/:id" element={<ReportDetailsPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/clients/:id" element={<ClientDetailsPage />} />
        <Route path="/cars" element={<CarsPage />} />
        <Route path="/cars/:id" element={<CarDetailsPage />} />
        <Route path="/models" element={<CarModelsPage />} />
        <Route path="/models/:id" element={<CarModelDetailsPage />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
